// extracted by mini-css-extract-plugin
export var hideEditor = "_kc-2";
export var infoIcon = "_kc-3";
export var label = "_kc-1";
export var labelContainer = "_kc-0";
export var readonlyText = "_kc-4";